var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgShuffleboard = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "#000000",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1295_274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6431 4C17.7903 4.04367 17.9395 4.08023 18.0835 4.13152C18.9844 4.45348 19.5363 5.25328 19.5394 6.25773C19.5441 8.00106 19.541 9.74488 19.541 11.4882C19.541 11.5877 19.541 11.6878 19.541 11.7817C25.4251 13.0132 28.4696 18.2309 28.3179 22.4209C28.1676 22.4209 28.0158 22.4209 27.8635 22.4209C27.1578 22.4209 26.4525 22.4153 25.7468 22.425C25.5681 22.4275 25.4788 22.3757 25.4019 22.2096C24.1803 19.5756 22.1369 17.8927 19.2756 17.2265C15.2073 16.2789 10.9629 18.3914 9.28496 22.1645C9.19358 22.3706 9.08774 22.43 8.86729 22.4265C8.034 22.4128 7.20071 22.4209 6.32251 22.4209C6.34213 19.8377 7.15786 17.5581 8.79759 15.5751C10.4404 13.588 12.5629 12.3495 15.1252 11.797C15.1252 11.6964 15.1252 11.6055 15.1252 11.5141C15.1252 9.8891 15.1629 8.26309 15.1138 6.63961C15.0756 5.36754 15.5775 4.32906 17.0231 4C17.2296 4 17.4361 4 17.6426 4H17.6431Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8173 30C16.5158 29.9386 16.2101 29.8918 15.9138 29.8126C13.4315 29.1489 11.7277 26.9003 11.8269 24.4278C11.9312 21.8293 13.7815 19.7198 16.3702 19.2476C19.5133 18.6743 22.5708 20.9757 22.8134 24.0982C23.0442 27.0684 20.9971 29.5572 17.996 29.9573C17.9459 29.9639 17.8984 29.9853 17.8493 30H16.8168H16.8173Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1295_274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 26,
    fill: "white",
    transform: "translate(6.32324 4)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShuffleboard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/shuffleboard.052f722a.svg";
export { ForwardRef as ReactComponent };